import { Box, CircularProgress } from "@mui/material";
import React, { Suspense, lazy, type ComponentProps } from "react";

const TalentExperienceDisplayReadOnly = lazy(() =>
  import("./TalentExperienceDisplayReadOnly").then((module) => ({
    default: module.default,
  })),
);

type TalentExperienceDisplayReadOnlyProps = ComponentProps<
  typeof import("./TalentExperienceDisplayReadOnly").default
>;

const ExperienceFallback = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 200,
      width: "100%",
    }}
  >
    <CircularProgress size={28} sx={{ color: "rgba(120,85,15,0.7)" }} />
  </Box>
);

/** Deferred load — breaks CardPreviewModal ↔ BonusDisplay circular import. */
const LazyTalentExperienceDisplayReadOnly: React.FC<TalentExperienceDisplayReadOnlyProps> = (
  props,
) => (
  <Suspense fallback={<ExperienceFallback />}>
    <TalentExperienceDisplayReadOnly {...props} />
  </Suspense>
);

export default LazyTalentExperienceDisplayReadOnly;
